import { createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ill_spot_info_tnc.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-0a953b26")

_pushScopeId("data-v-0a953b26")
const _hoisted_1 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-lp-300 font-semibold text-xl" }, "Informasi Penting", -1)
const _hoisted_2 = { class: "text-gray-lp-300" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "flex flex-row items-center justify-center" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    width: "287.66",
    alt: "info"
  })
], -1)
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "flex flex-row items-center gap-2 py-4 border-t border-gray-lp-1600" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}, " Saya setuju komoditas dalam paket sudah sesuai dengan komoditas yang ada pada informasi detail shipment di sistem. ", -1)
const _hoisted_7 = { class: "flex flex-row items-center gap-2 py-4 border-t border-gray-lp-1600" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}, " Saya setuju apabila tidak ada komoditas yang tertera pada informasi detail di sistem, maka akan dikategorikan sebagai komoditas General. ", -1)
const _hoisted_9 = { class: "flex flex-row items-center gap-2 py-4 border-t border-b border-gray-lp-1600" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  class: "text-sm",
  style: {"line-height":"17.07px"}
}, [
  /*#__PURE__*/_createTextVNode(" Saya setuju bahwa komoditas yang dikirim, bukan komoditas yang dilarang untuk dilakukan pengiriman. "),
  /*#__PURE__*/_createVNode("a", {
    href: "https://bit.ly/SKCommodityLionParcel",
    target: "_blank",
    class: "text-red-lp-200 font-bold"
  }, " Lihat detailnya. ")
], -1)
const _hoisted_11 = { class: "flex flex-col gap-6" }
const _hoisted_12 = { class: "flex flex-row items-center" }
const _hoisted_13 = /*#__PURE__*/_createVNode("div", {
  class: "text-xs text-gray-lp-300 font-semibold",
  style: {"margin-left":"2.5px"}
}, " Dengan ini saya menyetujui dan ingin melanjutkan proses booking. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_ModalV2 = _resolveComponent("ModalV2")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_ModalV2, {
        key: 0,
        isCustomTitle: "",
        width: "instant-booking-popup",
        onClose: 
      () => {
        _ctx.$emit('close');
        _ctx.agreements = [false, false, false];
      }
    
      }, {
        "custom-title": _withId(() => [
          _hoisted_1
        ]),
        content: _withId(() => [
          _createVNode("section", _hoisted_2, [
            _hoisted_3,
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[0],
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.agreements[0] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _hoisted_6
              ]),
              _createVNode("div", _hoisted_7, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[1],
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.agreements[1] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _hoisted_8
              ]),
              _createVNode("div", _hoisted_9, [
                _createVNode(_component_Checkbox, {
                  modelValue: _ctx.agreements[2],
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.agreements[2] = $event)),
                  binary: ""
                }, null, 8, ["modelValue"]),
                _hoisted_10
              ])
            ])
          ])
        ]),
        footer: _withId(() => [
          _createVNode("div", _hoisted_11, [
            _createVNode("div", _hoisted_12, [
              _createVNode(_component_Checkbox, {
                binary: true,
                modelValue: _ctx.isAgree,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isAgree = $event)),
                disabled: _ctx.isNotValid
              }, null, 8, ["modelValue", "disabled"]),
              _hoisted_13
            ]),
            _createVNode(_component_LpButton, {
              disabled: !_ctx.isAgree || _ctx.controller.isLoading,
              isWidthFull: "",
              title: "Lanjutkan booking",
              textColor: "white",
              customClass: "py-3",
              onClick: _ctx.onConfirm
            }, null, 8, ["disabled", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onClose"]))
    : _createCommentVNode("", true)
})